import { useContext } from "react";
import ConfigContext from "./index";

const useConfigs = () => {
  return useContext(ConfigContext);
};

export default useConfigs;
